exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlink {\n  text-decoration: underline;\n}\n.vlink:hover {\n  text-decoration: underline;\n}\n", ""]);

// exports
